export default __webpack_public_path__ + "static/banner_nlp-16d559a555715fb6ca26ddbf869108e1.webp";